import { API_PATHS } from "../API_PATHS";
import { request } from "../utils";

export const getProjectDoughnutChartData = (
  SyncLogId: string,
  orgId: number,
  tenantId: number,
) => {
  const url = "ProjectSummaryReport/GetBudgetCostByBusinessSponsor";
  return request({
    method: "GET",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.PROJECT_SUMMARY.GET_DOUGHNUT_CHART(SyncLogId, orgId, tenantId, url)}`,
  });
};

export const getProjectVerticalBarChartData = (
  SyncLogId: string,
  orgId: number,
  tenantId: number,
) => {
  const url = "ProjectSummaryReport/GetBudgetCostByProjectPhase";
  return request({
    method: "GET",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.PROJECT_SUMMARY.GET_VERTICAL_CHART(SyncLogId, orgId, tenantId, url)}`,
  });
};

export const getProjectHeader = (
  SyncLogId: string,
  orgId: number,
  tenantId: number,
) => {
  return request({
    method: "GET",
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.PROJECT_SUMMARY.GET_HEADER_INFO(SyncLogId, orgId, tenantId)}`,
  });
};
